import {
  inject,
  observer,
} from 'mobx-react';

import {
  WeaLocaleProvider,
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import {
  format
} from './util'

export default class Footnote extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{float:'right', paddingRight: 16}}>
        {`${getLabel('391162',"本报表数据统计截止到: ")} ${format('yyyy-MM-dd hh:mm')}`}
      </div>
    )

  }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/applicant/Footnote.js